import { type FC, useMemo } from 'react';
import { Show, ShowFirstMatching } from '@components/Show';
import type { Team } from '@domain/schemas/team.schema';

import type { EntityModalType, StepProps } from '../types';
import { Step } from '../types';
import { getStepComponents } from '../utils';

interface FormContentProps extends StepProps {
  currentStep: Step;
  type: EntityModalType;
  userTeams: Team[];
  isFetchingTeams: boolean;
}

export const FormContent: FC<FormContentProps> = ({ currentStep, type, userTeams, ...stepProps }) => {
  const { Step1, Step2, Step3 } = useMemo(() => getStepComponents(type), [type]);

  return (
    <ShowFirstMatching>
      <Show when={currentStep === Step.GeneralEntityData}>
        <Step1 {...stepProps} currentStep={currentStep} userTeams={userTeams} />
      </Show>
      <Show when={currentStep === Step.BaseEntityData}>
        <Step2 {...stepProps} />
      </Show>
      <Show when={currentStep === Step.BrandingInfo}>
        <Step3 {...stepProps} />
      </Show>
    </ShowFirstMatching>
  );
};
